import React from 'react'

export type ColumnFilterProps = {
  column: { id: string }
  filter?: any
  onChange: (e: string) => void
}

// Custom Filter component to be used in ReactTable
export const ColumnFilter = (props: ColumnFilterProps) => {
  const { column, filter, onChange } = props
  return (
    <input
      aria-label={`Filter by: ${column.id}`}
      value={filter?.value || ''}
      autoComplete="off"
      onChange={(e) => {
        onChange(e.target.value)
      }}
    />
  )
}
export default ColumnFilter
